import { useEffect } from 'react';
import { useShopById, useUpdateShopById } from '../../../redux/hooks/shops';
import { isPODShop } from '../helpers';

const EnsurePodCheckoutDefaults = ({ shop_id }: { shop_id: string }) => {
  const shop = useShopById(shop_id);
  const onUpdateShop = useUpdateShopById(shop_id);

  useEffect(() => {
    if (!isPODShop(shop)) {
      return;
    }
    if (+shop.allow_credit_card_checkout !== 1) {
      onUpdateShop('allow_credit_card_checkout', shop.allow_credit_card_checkout, 1);
    }
  }, [shop.shop_id, shop.shop_type, shop.allow_credit_card_checkout]);

  return null;
};

export default EnsurePodCheckoutDefaults;
